import { Box, Link, Typography } from '@mui/material';
import { useRef } from 'react';

function MessageCell({
  text,
  isTextHtml = false,
  onShowMore,
}: {
  text: string;
  isTextHtml?: boolean;
  onShowMore: () => void;
}) {
  const textRef = useRef(null);

  return (
    <Box>
      <Typography
        variant="body2"
        ref={textRef}
        style={{
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          overflow: 'hidden',
          whiteSpace: 'normal',
        }}
      >
        {!isTextHtml && text}
      </Typography>
      <Link sx={{ cursor: 'pointer', fontSize: '2rem', color: '#1976d2' }} onClick={onShowMore}>
        <Typography variant="body2">Show more</Typography>
      </Link>
    </Box>
  );
}

export default MessageCell;
